export default "__VITE_ASSET__Q0u4FWtk__"